import React from 'react'
import { deviceDetect } from 'react-device-detect'
import MobMedicationsWrapper from './Mobile/Components/MobMedicationsWrapper'

const PatMedications = () => {
  if (deviceDetect().isMobile) return <MobMedicationsWrapper />
  else return <MobMedicationsWrapper /> // For now, use mobile version for both
}

export default PatMedications
